import 'slick-carousel';

const $win = $(window);
const $doc = $(document);

const sliderOptions = {
	autoplaySpeed: 5000,
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	arrows: false,
	infinite: true
}

$('.js-slider-hero').slick(sliderOptions);

$doc.on('shopify:section:load', function(event) {
	$('.js-slider-hero').slick(sliderOptions);
})